import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';
import { userSchema } from '../user/getUsers';

const deviceSchema = baseObjectSchema.extend({
  code: z.string(),
  name: z.string(),
  remarks: z.string().nullish(),
  updateUser: userSchema.nullish(),
  createUser: userSchema.nullish(),
});

const documentTypeSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
});

const documentSeriesSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
});

const deviceConfigurationSchema = baseObjectSchema.extend({
  code: z.string().optional(),
  name: z.string().optional(),
  functionality: z.number(),
  functionalityString: z.string().optional(),
  loadItemLines: z.number(),
  deviceID: z.string(),
  documentTypeID: z.string(),
  documentSeriesID: z.string(),
  defaultUserID: z.string().optional(),
  device: deviceSchema.optional(),
  documentType: documentTypeSchema.optional(),
  documentSeries: documentSeriesSchema.optional(),
  companySiteID: z.string(),
  companySite: z.object({ id: z.string(), name: z.string() }).optional(),
  user: userSchema.optional(),
  recordMode: z.number().optional(),
});

export const getDevicesSchema = z.array(
  baseObjectSchema.extend({
    code: z.string(),
    name: z.string(),
    remarks: z.string().optional(),
    lastLogin: z.string().optional(),
    updateUser: userSchema.optional(),
    createUser: userSchema.optional(),
    deviceConfigurations: z.array(deviceConfigurationSchema).optional(),
  })
);

export type GetDevicesResponse = z.infer<typeof getDevicesSchema>;
